import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export function GuaranteeSection() {
  return <section className="py-14 md:py-20 bg-zinc-900 pt-[20px] pb-[20px]" data-id="element-142">
      <div className="container mx-auto px-5 sm:px-6 md:px-8" data-id="element-143">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="max-w-4xl mx-auto mt-[-20px] mb-[-20px]" data-id="element-144">
          <div className="text-center mb-16" data-id="element-145">
            <ShieldCheckIcon className="w-24 h-24 text-green-500 mx-auto drop-shadow-[0_0_30px_rgba(34,197,94,0.3)] mt-[20px] mb-[20px]" data-id="element-146" />
            <h2 className="text-4xl md:text-6xl lg:text-7xl font-display text-white uppercase tracking-tight leading-[0.95] mt-[-10px] mb-[-10px]" data-id="element-147">
              Garantía{' '}
              <span className="text-green-500" data-id="element-148">"Arrancá Sin Riesgo"</span> — 7
              días
            </h2>
          </div>

          <div className="bg-black/50 border border-green-600/30 rounded-3xl p-8 md:p-16 space-y-8 text-lg md:text-xl leading-relaxed shadow-2xl relative overflow-hidden mt-[0px] mb-[0px]" data-id="element-149">
            <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-green-600 to-green-400 mt-[0px] mb-[0px]" data-id="element-150"></div>

            <p className="text-white font-display text-2xl md:text-3xl tracking-wide mt-[-10px] mb-[-10px]" data-id="element-151">
              Probá Plan Anti Panza durante{' '}
              <span className="text-green-500" data-id="element-152">7 días completos.</span>
            </p>

            <p className="text-zinc-300" data-id="element-153">
              No quiero que compres este ebook con dudas, miedo o pensando:
            </p>

            <div className="bg-zinc-900/80 border-l-4 border-zinc-700 p-6 rounded-r-xl" data-id="element-154">
              <p className="text-zinc-400 italic text-xl md:text-2xl font-medium" data-id="element-155">
                "¿Y si es otra dieta más que no voy a poder sostener?"
              </p>
            </div>

            <p className="text-zinc-300" data-id="element-156">
              Por eso tenés <strong data-id="element-157">7 días de garantía</strong> para entrar,
              leerlo, revisar el plan, ver los bonos y comprobar si realmente
              sentís que este sistema te da claridad para empezar a bajar la
              panza sin pasar hambre, sin dietas extremas y sin vivir en el
              gimnasio.
            </p>

            <p className="text-zinc-300" data-id="element-158">
              Si dentro de esos 7 días sentís que el ebook no te ayuda a
              entender qué comer, cómo organizarte o cómo empezar tu proceso,{' '}
              <strong data-id="element-159">simplemente escribís y te devolvemos el dinero.</strong>
            </p>

            <div className="flex flex-col md:flex-row gap-4 md:gap-8 justify-center text-center py-6 border-y border-zinc-800" data-id="element-160">
              <p className="text-white font-bold uppercase tracking-wider" data-id="element-161">
                ✅ Sin vueltas.
              </p>
              <p className="text-white font-bold uppercase tracking-wider" data-id="element-162">
                ✅ Sin preguntas raras.
              </p>
              <p className="text-white font-bold uppercase tracking-wider" data-id="element-163">
                ✅ Sin hacerte perder tiempo.
              </p>
            </div>

            <p className="text-zinc-300" data-id="element-164">
              Mi objetivo no es que compres otro PDF más y lo dejes tirado.
            </p>

            <p className="text-zinc-300" data-id="element-165">
              Mi objetivo es que tengas un <strong data-id="element-166">sistema claro</strong> para
              saber qué hacer durante las próximas 12 semanas y puedas decir:
            </p>

            <p className="text-green-400 font-display text-3xl text-center italic tracking-wide py-4" data-id="element-167">
              "Ahora sí entiendo cómo empezar."
            </p>

            <p className="text-zinc-400 text-center text-base uppercase tracking-widest font-bold" data-id="element-168">
              Si no sentís eso en los primeros 7 días, no asumís ningún riesgo.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}